import { withInstall } from "../utils/index.mjs";
import _Form from "./Form.mjs";
const Form = withInstall(_Form);
var stdin_default = Form;
import { formProps } from "./Form.mjs";
export {
  Form,
  stdin_default as default,
  formProps
};
